import { CHECKBOOK_CONTROLLED_SDIRA } from "@api/services/investments/shapes/SdiraTypeEnum"

import isSdiraInvestment from "./isSdiraInvestment"
import isEntityInvestment from "./isEntityInvestment"


const computeInvestmentName = (computeAccountFullname, investment) => {
  const isSdira = isSdiraInvestment(investment)
  const isEntity = isEntityInvestment(investment)

  const { name, investorAccountId, profileSdira } = investment
  const investorName = computeAccountFullname(investorAccountId)

  const isNotDefined = name === 'NA'

  if (isNotDefined) {
    return investorName
  }

  if (isEntity) {
    return `${investorName} - ${name}`
  }

  if (isSdira) {
    const { sdiraType, entityName } = profileSdira || {}
    const isCheckbookControlled =  sdiraType === CHECKBOOK_CONTROLLED_SDIRA
    const displayName = isCheckbookControlled ? entityName : name

    return `${investorName} - ${displayName}`
  }

  return name
}

export default computeInvestmentName
